import React from "react";
import { useParams } from "react-router-dom";
import { FormPollVote } from "../components/polls";

/**
 * Vue EMBED du formulaire — version nue (sans header produit ni sidebar) destinée
 * à être affichée dans une iframe sur un site tiers (Phase 6 prod-readiness).
 * Le framing cross-origin est autorisé pour /embed/* uniquement (cf. vercel.json),
 * pas pour le reste de l'app (protection clickjacking).
 */
export default function EmbedVote() {
  const { slug } = useParams<{ slug: string }>();
  return (
    <div className="min-h-screen bg-white">
      <FormPollVote idOrSlug={slug!} />
    </div>
  );
}
